import FormSelect from './FormSelect';

const CourseSelection = ({
  formData,
  courses,
  dispatch,
  getFieldStyle = null,
  disableWhenBatchSet = false,
  required = true,
  label = 'Select Course for Student',
}) => {
  // Filter out null/undefined courses and ensure we have valid data
  const validCourses = Array.isArray(courses) 
    ? courses.filter(c => {
        // More lenient check - just ensure it's an object with an id
        if (!c || typeof c !== 'object') {
          return false;
        }
        // Check if id exists (can be number, string, etc.)
        const hasId = c.id !== undefined && c.id !== null;
        return hasId;
      })
    : [];
  
  // Handle course selection change
  const handleCourseChange = (e) => {
    const selectedCourseId = e.target.value;
    dispatch({ type: 'UPDATE_FIELD', field: 'courseId', value: selectedCourseId });
    
    // Auto-populate course category based on selected course
    if (selectedCourseId) {
      const selectedCourse = validCourses.find(c => String(c.id) === String(selectedCourseId));
      if (selectedCourse) {
        // Check for categoryId or category.id (handle both direct and nested structures)
        let categoryId = null;
        
        // Try direct categoryId first
        if (selectedCourse.categoryId !== undefined && selectedCourse.categoryId !== null) {
          categoryId = selectedCourse.categoryId;
        }
        // Try nested category object
        else if (selectedCourse.category) {
          if (typeof selectedCourse.category === 'object') {
            categoryId = selectedCourse.category.id || selectedCourse.category.categoryId;
          } else {
            categoryId = selectedCourse.category; // In case category is just an ID
          }
        }
        
        if (categoryId) {
          console.log('✅ Auto-populating course category:', {
            courseId: selectedCourseId,
            courseName: selectedCourse.courseName,
            categoryId: categoryId,
            category: selectedCourse.category
          });
          dispatch({ type: 'UPDATE_FIELD', field: 'courseCategoryId', value: String(categoryId) });
        } else {
          console.warn('⚠️ Course does not have a category assigned:', {
            courseId: selectedCourseId,
            courseName: selectedCourse.courseName,
            courseData: selectedCourse
          });
          // Clear category if course doesn't have one
          dispatch({ type: 'UPDATE_FIELD', field: 'courseCategoryId', value: '' });
        }
      }
    } else {
      // Clear category if no course is selected
      dispatch({ type: 'UPDATE_FIELD', field: 'courseCategoryId', value: '' });
    }
  };
  
  // Render the dropdown - on Edit form, disable when batch is set (pre-filled from enrollment)
  const isPreFilled = (formData.batchId && formData.courseId) || (disableWhenBatchSet && !!formData.batchId);
  
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium mb-2" style={{ color: 'var(--color-text)' }}>
        {label} {required ? <span className="text-red-500">*</span> : null}
        {isPreFilled && <span className="text-xs text-gray-500 ml-2">(Pre-filled - not editable)</span>}
      </label>
      <FormSelect
        name="courseId"
        value={formData.courseId || ''}
        onChange={handleCourseChange}
        required={required}
        disabled={isPreFilled || validCourses.length === 0}
        placeholder={
          validCourses.length > 0
            ? '-- Select Course for Student --'
            : courses === undefined
              ? 'Loading courses...'
              : courses === null
                ? 'No courses loaded'
                : courses.length === 0
                  ? 'No courses available'
                  : `No valid courses (received ${courses.length} but none passed validation)`
        }
        options={validCourses}
        getOptionLabel={(course) => {
          const courseName =
            course.courseName || course.name || course.title || course.course_name;
          const displayName = courseName ? String(courseName).trim() : '';
          return displayName || `Course ${course.id}`;
        }}
        getOptionValue={(course) => String(course.id)}
      />
      {validCourses.length > 0 && (
        <p className="text-xs text-gray-500 mt-1">
          ✓ {validCourses.length} course(s) available
        </p>
      )}
      {validCourses.length === 0 && courses && courses.length > 0 && (
        <p className="text-xs text-red-500 mt-1">
          ⚠️ Warning: {courses.length} course(s) received but none passed validation. Check console for details.
        </p>
      )}
      {validCourses.length === 0 && (!courses || courses.length === 0) && (
        <p className="text-xs text-yellow-500 mt-1">
          ℹ️ No courses loaded yet. Make sure you're logged in and the API is accessible.
        </p>
      )}
    </div>
  );
};

export default CourseSelection;



